import { useQuery } from "@tanstack/react-query"
import { getProductSubcategories } from "@/lib/api/product.api"
import { useAuthStore } from "@/store/auth.store"

export function useProductSubcategories(category: string | null) {
  const accessToken = useAuthStore((s) => s.accessToken)

  return useQuery({
    queryKey: ["product-subcategories", category],
    queryFn: () => getProductSubcategories(category!, accessToken ?? undefined),
    enabled: !!category,
    staleTime: 1000 * 60 * 60, // 1 hour
    refetchOnWindowFocus: false,
  })
}